import idToNature from 'data/output/id-to-nature.json'

const getNature = (id) => {
  return idToNature[id]
}

export default getNature
